import React from "react";

const ConsignmentBalanceTable = () => {
  return (
    <div>
      <h3>Table</h3>
    </div>
  );
};

export default ConsignmentBalanceTable;
